import React from 'react';
import Items from '../Items';
import { LessonBlock } from '../types';

export default function ArrowList({ block }: { block: LessonBlock }) {
  return (
    <>
      {block.introText && <p className="pc-lesson-p">{block.introText}</p>}
      <div className="pc-lesson-arrows">
        {(block.pairs || []).map((pair, i) => (
          /* eslint-disable-next-line react/no-array-index-key */
          <div className="pc-lesson-arrow" key={i}>
            <span className="pc-lesson-arrow-mark" aria-hidden="true">arrow_forward</span>
            <div>
              <h3 className="pc-lesson-arrow-title">{pair.title}</h3>
              <p className="pc-lesson-p">{pair.body}</p>
            </div>
          </div>
        ))}
      </div>
      {block.hasTail && <Items items={block.tailItems || []} />}
    </>
  );
}
